export const sliderData = [
    {
      image: "https://i.ibb.co/WkqjtZ8/slideshow-1.png",
    },
    {
      image: "https://i.ibb.co/Cn0XX8v/slideshow-2.png",
    },
    {
      image: "https://i.ibb.co/180Hj6V/slideshow-3.png",
    },
  ]; 